import { badWords } from "./helper";
import axios from "axios";

axios.create({
    baseURL: DW_API
});

export const addErrorValidate = (field, message) => {
    field.classList.add("mktoInvalid");
    field.classList.add("invalid");

    let elError = document.createElement("div");
    elError.classList.add("mktoCustomError");
    elError.innerHTML = message;
    $('.loader').css('display','none');
    field.parentNode.insertBefore(elError, field.nextSibling);
};

export const detectMob = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};

export const getBrowserName = () => {
    // Opera 8.0+
    let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

    // Firefox 1.0+
    let isFirefox = typeof InstallTrigger !== "undefined";

    // Safari 3.0+ "[object HTMLElementConstructor]"
    let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window.safari || (typeof safari !== "undefined" && window.safari.pushNotification));

    // Internet Explorer 6-11
    let isIE = /*@cc_on!@*/!!document.documentMode;

    // Edge 20+
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") !== -1);

    let browser = "";
    if (isOpera) {
        browser = "Opera";
    } else if (isFirefox) {
        browser = "Mozilla Firefox";
    } else if (isSafari) {
        browser = "Safari";
    } else if (isIE) {
        browser = "IE";
    } else if (isEdge) {
        browser = "Edge";
    } else if (isChrome) {
        browser = "Google Chrome";
    } else if (isEdgeChromium) {
        browser = "Edge Chrome";
    }
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        browser = "Opera";
    } else if (navigator.userAgent.indexOf("Edg") != -1) {
        browser = "Edge";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        browser = "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
        browser = "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browser = "Firefox";
    } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
        browser = "IE";
    } else {
        browser = "unknown";
    }

    return browser;
};

export const getOperatingSystem = () => {
    let OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";
    return OSName;
};

export const getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
};

export const validateBadWords = (field, errorMessage) => {
    let words = badWords;
    let check = true;
    for (let i = 0; i < words.length; i++) {
        if (new RegExp("\\b" + words[i] + "\\b", "i").test(field.value.toLowerCase())) {
            addErrorValidate(field, errorMessage);
            check = false;
            break;
        }
    }
    return check;
};

export const checkEmail = (payload, field) => {
    return new Promise((resolve, reject) => {
        // Updated regex to be more permissive and handle all valid email formats
        // Allows: hyphens, underscores, numbers, dots, plus signs in local part
        // Allows: hyphens, numbers, multiple subdomains in domain part
        // Examples: 
        // - aahirepatil1125-sf-1@infogroup.mailinator.com
        // - ajasdy_sf_123@infogroup.mailinator.com
        // - user+tag@example.com
        // Simple and permissive pattern that handles all common email formats
        let validRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Trim email and convert to lowercase for validation
        let emailToValidate = (payload.email || '').trim().toLowerCase();
        
        if (!emailToValidate || !validRegex.test(emailToValidate)) {
            addErrorValidate(field, "Must be valid email.");
            reject();
            return;
        }

        // If xverify is disabled, just resolve
        if(!Ed_hideByteplan){
            resolve();
        } else {
            // Call xverify API for additional validation
            let payloadData={
                email: emailToValidate,
                // domain:`${VALIDATOR_EMAIL_KEY}`,
                // APIKey: `${VALIDATOR_EMAIL_KEY}`
            };
            axios.post(`/xverify/email`, payloadData).then(function (response) {
                // Handle different response formats
                let responseData = response.data;
                
                // If response is a string, try to parse it as JSON
                if (typeof responseData === 'string') {
                    try {
                        responseData = JSON.parse(responseData);
                    } catch (e) {
                        // Response is not valid JSON, treating as string
                    }
                }
                
                // Check if response has status field
                let status = null;
                if (responseData && typeof responseData === 'object') {
                    status = responseData.status || responseData.Status || responseData.STATUS;
                }
                
                // Accept these statuses as valid
                if (status && (status == "accept_all" || status == "risky" || status == "valid" || status == "unknown")) {
                    resolve();
                } else {
                    // If response is empty, null, or doesn't have a clear rejection status,
                    // accept the email since regex validation already passed
                    if (!responseData || responseData === '' || (typeof responseData === 'object' && Object.keys(responseData).length === 0)) {
                        resolve();
                    } else {
                        // Even if xverify rejects, if regex passed, we can still accept it
                        // This prevents valid emails from being rejected due to API issues
                        resolve(); // Accept the email if regex passed
                    }
                }
            }).catch((error) => {
                // If API fails, fall back to regex validation (which already passed)
                // This ensures emails with valid format aren't rejected due to API issues
                resolve(); // Accept the email if regex passed, even if API fails
            });
        }

    });
};

// Helper function to check phone in database
function checkPhoneInDatabase(formattedPhone, trimmedPhone) {
    return new Promise((resolve, reject) => {
        // Backend expects formatted phone: (XXX)XXX-XXXX
        axios.post('/hubspot-form-byte-1', {
            phone: formattedPhone
        }).then(function (response) {
            if (response && response.data && response.data.data) {
                try {
                    var phoneStatusResponse = JSON.parse(response.data.data.response);
                    window.phone_status = phoneStatusResponse.status;
                    window.line_type = (phoneStatusResponse.linetype) ? phoneStatusResponse.linetype : "Unknown";
                    
                    // Set cookies with formatted phone
                    setCookie(formattedPhone + "_phone_status", window.phone_status, 30);
                    setCookie(formattedPhone + "_line_type", window.line_type, 30);
                    
                    // Map API status to our status format
                    if (window.phone_status == "VALID_CONFIRMED" || window.phone_status == "VALID_UNCONFIRMED") {
                        window.phone_status = "Valid";
                    } else if (window.phone_status == "INVALID") {
                        window.phone_status = "Invalid";
                    }
                    
                    resolve(true); // Phone found in database (status is set, caller will check if invalid)
                } catch (e) {
                    resolve(false); // Error parsing, try API
                }
            } else {
                resolve(false); // Not in database
            }
        }).catch(function(error) {
            resolve(false); // Error, try API
        });
    });
}

// Helper function to validate phone with API
function validatePhoneWithAPI(formattedPhone, trimmedPhone, field) {
    return new Promise((resolve, reject) => {
        // Use phone-validator.net API (same as reference code)
        const apiUrl = `https://api.phone-validator.net/api/v2/verify?PhoneNumber=${encodeURIComponent(formattedPhone)}&CountryCode=us&APIKey=pv-432c2ebbc71ef1f6bf017eeff8818eda`;
        
        fetch(apiUrl).then(function(response) {
            if (!response.ok) {
                throw new Error('API response not ok');
            }
            return response.json();
        }).then(function(dataByte) {
            // Set phone status and line type
            if(dataByte.status === "VALID_CONFIRMED" || dataByte.status === "VALID_UNCONFIRMED"){
                window.phone_status = "Valid";
            } else if(dataByte.status === "INVALID"){
                window.phone_status = "Invalid";
            } else {
                window.phone_status = "Unknown";
            }
            
            window.line_type = (dataByte.linetype) ? dataByte.linetype : "Unknown";
            
            // Set cookies with formatted phone
            setCookie(formattedPhone + "_phone_status", window.phone_status, 30);
            setCookie(formattedPhone + "_line_type", window.line_type, 30);
            
            // Save to database - backend expects formatted phone: (XXX)XXX-XXXX
            let bytePlantPhonedata = {
                phone: formattedPhone,
                count: 1,
                response: JSON.stringify(dataByte)
            };
            
            axios.post('/hubspot-form-byte', bytePlantPhonedata).then(function (response) {
                // Phone validation data saved to DB
            }).catch(function(error) {
                // Error saving to DB
            });
            
            // If phone is invalid, reject the promise to prevent form submission
            if(window.phone_status === "Invalid"){
                addErrorValidate(field, "Must be a valid phone number.");
                reject(new Error('Invalid phone number'));
                return;
            }
            
            resolve(true);
        }).catch(function(error) {
            reject(error);
        });
    });
}

export const checkPhone = (payload, field) => {
    return new Promise((resolve, reject) => {
        // Validate phone format first
        let regex = /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/;
        if (!regex.test(payload.phone)) {
            addErrorValidate(field, "Must be a valid 10 digit phone number.");
            reject();
            return;
        }
        
        // Initialize phone status and line type
        window.phone_status = "Unknown";
        window.line_type = "Unknown";
        
        // Check cookies first (using formatted phone like "(987)982-1766")
        const cookieStatus = getCookie(payload.phone + "_phone_status");
        const cookieLineType = getCookie(payload.phone + "_line_type");
        
        if (cookieStatus !== null && cookieStatus !== undefined && cookieStatus !== '') {
            window.phone_status = cookieStatus;
        }
        if (cookieLineType !== null && cookieLineType !== undefined && cookieLineType !== '') {
            window.line_type = cookieLineType;
        }
        
        // Get trimmed phone (remove +1 prefix, just digits) for database lookup
        let trimmedPhone = payload.phone.replace(/^\+[0-9]/, '').replace(/\D/g, '');
        
        // If phone validation is disabled, resolve immediately
        if(Ed_hideByteplan == 'off'){
            resolve();
            return;
        }
        
        // Check if phone status is undefined, null, empty string, or Unknown
        if(window.phone_status === null || window.phone_status === undefined || window.phone_status === '' || window.phone_status === 'Unknown'){
            // Step 1: Check database first (using trimmed phone)
            checkPhoneInDatabase(payload.phone, trimmedPhone).then(function(dbResult) {
                if (dbResult) {
                    // Phone found in database, check if it's invalid
                    if(window.phone_status === "Invalid"){
                        addErrorValidate(field, "Must be a valid phone number.");
                        reject(new Error('Invalid phone number'));
                        return;
                    }
                    resolve();
                } else {
                    // Step 2: Not in database, use phone-validator.net API
                    validatePhoneWithAPI(payload.phone, trimmedPhone, field).then(function(apiResult) {
                        resolve(); // Phone is valid
                    }).catch(function(error) {
                        // If API validation fails or phone is invalid, reject
                        reject(error);
                    });
                }
            }).catch(function(error) {
                // If DB check fails, try API
                validatePhoneWithAPI(payload.phone, trimmedPhone, field).then(function(apiResult) {
                    resolve();
                }).catch(function(error) {
                    // If API validation fails or phone is invalid, reject
                    reject(error);
                });
            });
        } else {
            // Phone exists in cookie, update count and resolve
            // Backend expects formatted phone: (XXX)XXX-XXXX
            let phoneData = {
                phone: payload.phone
            };
            
            // Update count in database (non-blocking)
            axios.post('/hubspot-form-byte_count', phoneData).then(function (response) {
                // Count updated
            }).catch(function(error) {
                // Count update error
            });
            
            // Map API status to our status format
            if (window.phone_status == "VALID_CONFIRMED" || window.phone_status == "VALID_UNCONFIRMED") {
                window.phone_status = "Valid";
            } else if (window.phone_status == "INVALID") {
                window.phone_status = "Invalid";
                // If phone is invalid, reject to prevent form submission
                addErrorValidate(field, "Must be a valid phone number.");
                reject(new Error('Invalid phone number'));
                return;
            }
            
            resolve();
        }
    });
};

export const getUrlParameter = (sParam) => {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

export const getCookie = (cname) => {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(cname == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }

    // Return null if not found
    return null;
};

export const getTrackingParams = (tracking_params) => {
    let track = false;
    let tp_decode_url = decodeURIComponent(tracking_params);
    if (tracking_params && tp_decode_url && Object.entries(JSON.parse(tp_decode_url)).length > 1) {
        track = true;
    }
    return track;
};

export const deleteCookie = (cname) => {
    document.cookie = cname +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const setCookie = (cName, cValue, expDays) => {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    // Add SameSite=Lax for better cookie handling across redirects
    document.cookie = cName + "=" + encodeURIComponent(cValue) + "; " + expires + "; path=/; SameSite=Lax";
};
